import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { FinancialShadcnComponent } from 'app/components/analytics-financial/FinancialShadcnComponent'
import { useFinancialPage } from 'app/components/analytics-financial/useFinancialPage'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'

// observer: reads the staff-v2 feature toggle in render; useFeatureToggle resolves
// false -> real asynchronously and its contract requires an observer wrapper (TRK-6020).
const Financial = observer(function Financial() {
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()

  if (staffV2Enabled && !checkPermission([`org:pages:analytics:revenue`, `pages:analytics`])) {
    return <Navigate to="/analytics/marketing" replace />
  }

  const props = useFinancialPage()
  return <FinancialShadcnComponent {...props} />
})

export default Financial
